export const searchTaxonomyByKey = (taxonomy, key) => {
  const tipo = taxonomy.filter(item => item.value === key);
  if (tipo.length > 0) {
    return tipo[0];
  }
  return null;
};

export const searchTaxonomyByValue = (taxonomy, value) => {
  const tipo = taxonomy.filter(item => item.text === value);
  if (tipo.length > 0) {
    return tipo[0];
  }
  return null;
};

export const processTaxonamyResponse = (response) => {
  const result = [];
  if (response.data && response.data.data && response.data.data.length > 0) {
    response.data.data.forEach((item) => {
      result.push(Object.assign({}, item.attributes, { value: item.id, text: item.attributes.name }));
    });
  }
  return result;
};

export const proccessTaxonomyNames = (response) => {
  const result = [];
  if (response.data && response.data.data && response.data.data.length > 0) {
    response.data.data.forEach((item) => {
      result.push({ name: item.attributes.name, value: item.attributes.vid });
    });
  }
  return result;
};




// WEBPACK FOOTER //
// ./src/features/taxonomy/utils.js